var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 0.00195312C23.9559 0.00195312 0 23.9531 0 53.4996C0 83.0461 23.9535 106.997 53.5 106.997C83.0488 106.997 107 83.0461 107 53.4996C107 23.9531 83.0488 0.00195312 53.5 0.00195312ZM53.5 15.9984C58.1931 15.9981 62.6942 17.8621 66.0129 21.1804C69.3317 24.4987 71.1963 28.9995 71.1966 33.6927C71.197 38.3858 69.3329 42.8868 66.0146 46.2056C62.6963 49.5244 58.1955 51.389 53.5023 51.3893C48.8092 51.3896 44.3082 49.5256 40.9894 46.2073C37.6707 42.8889 35.806 38.3881 35.8057 33.695C35.8054 29.0019 37.6694 24.5008 40.9878 21.1821C44.3061 17.8633 48.8069 15.9987 53.5 15.9984ZM53.4883 93.0101C44.1133 93.0205 35.0441 89.6762 27.9203 83.5819C27.0913 82.8745 26.4254 81.9958 25.9686 81.0063C25.5118 80.0168 25.2749 78.9401 25.2742 77.8503C25.2742 67.9403 33.2947 60.0091 43.207 60.0091H63.7977C73.7123 60.0091 81.7023 67.9403 81.7023 77.8503C81.703 78.9397 81.4669 80.0164 81.0104 81.0056C80.5539 81.9948 79.8879 82.8731 79.0585 83.5795C71.9351 89.6764 62.8645 93.0217 53.4883 93.0101Z",
    fill: "#A67DDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpponent);
export default __webpack_public_path__ + "static/media/Opponent.8234bac03ee988be7ab1d3a3b8fc9735.svg";
export { ForwardRef as ReactComponent };